import { Box } from '@mui/material'
import { useEffect } from 'react'
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom'
import MainLayout from '../Component/Layout/MainLayout/MainLayout'
import Home from '../Pages/Home'
import { toast } from 'react-toastify'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { setAllColors, setAllSizes, setTeamId, setToken, setuserDetails } from '../Redux/Reducers/globalSlice'
import NotFound from '../Component/FallBack/NotFound'
import Login from '../Pages/Login'
import Store from '../Pages/Store'
import ProductListing from '../Pages/ProductListing'
import ProductDetails from '../Pages/ProductDetails'
import Cart from '../Pages/Cart'
import VenderDashboard from '../Pages/Vender/venderDashboard'
import VenderLayout from '../Component/Layout/venderLayout/VenderLayout'
import VenderProducts from '../Pages/Vender/venderProducts'
import AddorUpdateProduct from '../Pages/Vender/addorUpdateProduct'
import { RootState } from '../Redux/store'
import { ApiGetAllColors, ApiGetAllSizes } from '../Core/Apicall'
import { Color } from '../Models/Color'
import VenderOrders from '../Pages/Vender/venderOrders'
import MyOrders from '../Pages/MyOrders'
import OrderDetails from '../Pages/OrderDetails'

function AppRoutes() {
    const params = new URLSearchParams(window.location.search);
    const user_id = params.get('user_id');
    const token = params.get('token');
    const team_id = params.get('teamId');
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { userDetails, teamId, venderDetails } = useSelector((state: RootState) => state.global)


    const api = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        headers: {
            "Content-Type": "application/json",
        },
    });


    const getUserInfo = async () => {
        if (!token) return;
        dispatch(setToken(token))
        try {
            const res = await api.get("/user/userInfo", {
                headers: {
                    Authorization: token,
                },
                params: {
                    user_id: user_id,
                },
            });

            dispatch(setuserDetails(res?.data))
            navigate('/home')
            console.log("UserProfile Data -->", res);
        } catch (error: any) {
            navigate('/error')
            toast.error(error?.message || "Something went wrong");
        }
    };

    useEffect(() => {
        getUserInfo()
    }, [token])

    useEffect(() => {
        if (team_id) {
            dispatch(setTeamId(team_id))
        }
    }, [team_id])

    useEffect(() => {
        getColorList()
        getSizeList()
    }, [])

    console.log("Vender Details", venderDetails)

    const getColorList = async () => {
        try {
            const res = await ApiGetAllColors()
            if (res.status || res.success) {
                dispatch(setAllColors(res?.data))
            }
        } catch (error: any) {
            console.log(error)
            toast.error(error?.message || "Something went wrong");
        }
    }


    const getSizeList = async () => {
        try {
            const res = await ApiGetAllSizes()
            if (res.status || res.success) {
                dispatch(setAllSizes(res?.data))
            }
        } catch (error: any) {
            console.log(error)
            toast.error(error?.message || "Something went wrong");
        }
    }

    return (
        <Box className='h-100 w-100'>
            <Routes>
                <Route path="/" element={<Navigate to="/home" replace />} />
                <Route
                    path='/login'
                    element={
                        <MainLayout>
                            <Login />
                        </MainLayout>
                    }
                />
                <Route
                    path='/home'
                    element={
                        <MainLayout>
                            <Home />
                        </MainLayout>
                    }
                />
                <Route
                    path='/error'
                    element={
                        <NotFound />
                    }
                />
                {/* <Route
                    path='/store/:shopProfileId'
                    element={
                        <MainLayout>
                            <Store />
                        </MainLayout>
                    }
                /> */}
                <Route
                    path='/store/:teamId'
                    element={
                        <MainLayout>
                            <Store />
                        </MainLayout>
                    }
                />

                <Route
                    path='/products/:type'
                    element={
                        <MainLayout>
                            <ProductListing />
                        </MainLayout>
                    }
                />
                <Route
                    path='/products/product-category/:slug'
                    element={
                        <MainLayout>
                            <ProductListing />
                        </MainLayout>
                    }
                />
                <Route
                    path='/products/search-product/:searchTerm'
                    element={
                        <MainLayout>
                            <ProductListing />
                        </MainLayout>
                    }
                />
                <Route
                    path='/product-details/:sku'
                    element={
                        <MainLayout>
                            <ProductDetails />
                        </MainLayout>
                    }
                />
                <Route
                    path='/cart'
                    element={
                        <MainLayout>
                            <Cart />
                        </MainLayout>
                    }
                />
                <Route
                    path='/my-orders'
                    element={
                        <MainLayout>
                            <MyOrders />
                        </MainLayout>
                    }
                />
                <Route
                    path='/orders/:orderId'
                    element={
                        <MainLayout>
                            <OrderDetails />
                        </MainLayout>
                    }
                />

                <Route
                    path='/vender/Dashboard'
                    element={
                        <VenderLayout>
                            <VenderDashboard />
                        </VenderLayout>
                    }
                />
                <Route
                    path='/vender/Products'
                    element={
                        <VenderLayout>
                            <VenderProducts />
                        </VenderLayout>
                    }
                />
                <Route
                    path='/vender/addproduct'
                    element={
                        <VenderLayout>
                            <AddorUpdateProduct />
                        </VenderLayout>
                    }
                />
                <Route
                    path='/vender/orders'
                    element={
                        <VenderLayout>
                            <VenderOrders/>
                        </VenderLayout>
                    }
                />

                {/* <Route
                    path="*"
                    element={ if <NotFound />}
                /> */}
            </Routes>
        </Box>
    )
}

export default AppRoutes
